import type { ArticleBarChart, ArticleBarChartData, ArticleBarChartDataBar } from '~/modules/landing/interfaces';

const NO_BREAK_SPACE = '\u00A0';

function formatArticleBarChartValue(bar: ArticleBarChartDataBar, data: ArticleBarChartData, locale: string): string {
    const number = new Intl.NumberFormat(locale, {
        minimumFractionDigits: data.decimals,
        maximumFractionDigits: data.decimals,
    }).format(bar.value);

    if (data.unit === null) {
        return number;
    }

    return data.unit.position === 'prefix'
        ? `${data.unit.text}${NO_BREAK_SPACE}${number}`
        : `${number}${NO_BREAK_SPACE}${data.unit.text}`;
}

export function readArticleBarChartFromData(data: ArticleBarChartData, locale: string): ArticleBarChart {
    return {
        title: data.title,
        subtitle: data.subtitle ?? '',
        bars: data.bars.map((bar) => ({
            label: bar.label,
            value: formatArticleBarChartValue(bar, data, locale),
            amount: bar.value,
        })),
    };
}
